// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"7cb2d498","419":"21ca23b0","563":"918ae73a","787":"28cb0dcd","942":"3f10588c"}[chunkId] + ".chunk.js";
};